export const PPT_RESIZE = 'PPT-resize';
export const IMMEDIATELY_RESIZE = 'immediately-resize';
export const SCROLL_TO_CENTER = 'scroll-to-center';
